import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "membercard-container" }
const _hoisted_2 = ["src"]

import {onMounted, reactive, ref} from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
interface State {
  url: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MembershipCard',
  setup(__props) {

const image = ref<HTMLImageElement>();

const {t,locale} = useI18n();

const state = reactive<State>({
  url: '',
});

const loadImage = ()=>{
   axios.get('/api/user/membership-card', {
     responseType: 'blob'
   }).then(r=>{
      const url = window.URL.createObjectURL(new Blob([r.data]));
      image.value!.src = url;
   }).catch(()=>{
      console.log('error');
   });   
}

onMounted(()=>{
  loadImage();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(t)('memberCard.header')), 1),
    _createElementVNode("img", {
      class: "member-card",
      src: state.url,
      ref_key: "image",
      ref: image,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(_unref(t)('memberCard.text')), 1)
  ]))
}
}

})